import React from "react";
import { GenerateQuestions } from "./GenerateQuestions";

export function QuestionGroupCustomActions() {
  return (
    <>
      <GenerateQuestions />
    </>
  );
}
